<template>
    <DefaultHeader />

    <div :class="{ 'd-none': this.$store.state.hiddenBody }" class="container">
        <div class="row d-flex justify-content-center">
            <div class="col-12">
                <div class="card shadow my-2 p-3 bg-white rounded">
                    <div class="row d-flex justify-content-around align-items-center">

                        <div class="col col-md-4 my-1">
                            <VehicleNameDisplay :balise="baliseInfo"></VehicleNameDisplay>
                        </div>

                        <div class="col col-md-5 my-1">
                            <form>
                                <h5 class="text-center mb-3">Filtrer par date</h5>

                                <div class="row g-2 align-items-end">
                                    <div class="col-12 col-lg-5">
                                        <label class="form-label small fw-semibold mb-1" for="startDate">
                                            Début
                                        </label>
                                        <input id="startDate" class="form-control" type="datetime-local"
                                            v-model="startDate" required>
                                    </div>

                                    <div class="col-12 col-lg-5">
                                        <label class="form-label small fw-semibold mb-1" for="endDate">
                                            Fin
                                        </label>
                                        <input id="endDate" class="form-control" type="datetime-local" v-model="endDate"
                                            required>
                                    </div>

                                    <div class="col-12 col-lg-2 d-grid">
                                        <button class="btn btn-primary" type="button" @click="applyDateFilter">
                                            OK
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>

                    </div>
                    <div class="row mt-3">
                        <div class="col-12">
                            <div class="border rounded-3 bg-light">
                                <button class="btn w-100 d-flex justify-content-between align-items-center"
                                    type="button" @click="showAlarmTypeFilters = !showAlarmTypeFilters">
                                    <strong>Types d'alarmes</strong>
                                    <span>{{ showAlarmTypeFilters ? '▲' : '▼' }}</span>
                                </button>

                                <div v-if="showAlarmTypeFilters" class="p-3 border-top">
                                    <div class="d-flex justify-content-end mb-2">
                                        <button class="btn btn-sm btn-outline-secondary me-1" type="button"
                                            @click="selectAllAlarmTypes">
                                            Tout cocher
                                        </button>
                                        <button class="btn btn-sm btn-outline-secondary" type="button"
                                            @click="unselectAllAlarmTypes">
                                            Tout décocher
                                        </button>
                                    </div>

                                    <div class="d-flex flex-wrap gap-2">
                                        <div v-for="alarmType in alarmTypes" :key="alarmType.id" class="form-check">
                                            <input class="form-check-input" type="checkbox"
                                                :id="'alarm-type-' + alarmType.id" :value="alarmType.id"
                                                v-model="selectedAlarmTypeIds" @change="applyAlarmTypeFilter">

                                            <label class="form-check-label" :for="'alarm-type-' + alarmType.id">
                                                {{ alarmType.name }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row d-flex justify-content-center">
            <div class="col-12 d-flex flex-column justify-content-between">
                <div class="card shadow mt-2 my-md-0 p-3 bg-white rounded">
                    <div class="d-flex justify-content-center">
                        <nav aria-label="...">
                            <Pagination :totalPages="totalPages" :perPage="perPage" :currentPage="currentPage"
                                @pagechanged="onPageChange" />
                        </nav>
                    </div>

                    <div class="table-responsive">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">Evènement</th>
                                    <th scope="col">Date</th>
                                    <th scope="col">Adresse</th>
                                    <th scope="col">Alim</th>
                                    <th scope="col">Vitesse</th>
                                    <th scope="col">Coordonnées</th>
                                    <th scope="col">Direction</th>
                                    <th scope="col">Batterie</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(alert, index) in alerts" :key="index">
                                    <td>
                                        <AlarmName :balise="baliseInfo" :alarm="alert" />
                                    </td>

                                    <td>
                                        <div v-if="alert && alert.date">
                                            {{ alert.date }}
                                        </div>
                                        <div v-else>
                                            _
                                        </div>

                                        <div v-if="$isAdmin && alert && alert.createdAt" class="small text-muted">
                                            {{ alert.createdAt }}
                                        </div>
                                    </td>

                                    <td v-if="alert && alert.address">{{ alert.address }}</td>
                                    <td v-else>_</td>

                                    <td v-if="alert && alert.powerVoltage != null">
                                        <AlimDisplay :alim="alert.powerVoltage"></AlimDisplay>
                                    </td>
                                    <td v-else>_</td>

                                    <td v-if="alert && alert.speed != null">{{ alert.speed }} Km/h</td>
                                    <td v-else>_</td>

                                    <td v-if="alert && alert.latitude != null && alert.longitude != null">
                                        <LatLongDisplay :latitude="alert.latitude" :longitude="alert.longitude" />
                                    </td>
                                    <td v-else>_</td>

                                    <td v-if="alert && alert.direction != null">{{ alert.direction }}°</td>
                                    <td v-else>_</td>

                                    <td v-if="alert && alert.battery != null">
                                        <BatteryDisplay :battery="alert.battery" />
                                    </td>
                                    <td v-else>_</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="d-flex justify-content-center my-2">
                        <div class="row col-12 col-md-6">
                            <div class="d-flex justify-content-start">
                                <div class="col-8">
                                    <label for="resPerPage">Résultats par page :</label>
                                </div>
                                <div class="col-3">
                                    <select name="resPerPage" id="resPerPage" class="form-select" v-model="perPage"
                                        @change="setPerPage">
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="15">15</option>
                                        <option value="20">20</option>
                                        <option value="30">30</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-center">
                        <nav aria-label="...">
                            <Pagination :totalPages="totalPages" :perPage="perPage" :currentPage="currentPage"
                                @pagechanged="onPageChange" />
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <DefaultFooter />
</template>

<script>
import DefaultHeader from '@/components/DefaultHeader.vue'
import DefaultFooter from '@/components/DefaultFooter.vue'
import FormatHelper from '@/helpers/format.helper.js'
import AlarmRepository from '@/repositories/alarm.repo.js'
import Pagination from '@/components/PaginationComponent.vue'
import BatteryDisplay from '@/components/display/BatteryDisplay.vue'
import AlimDisplay from '@/components/display/AlimDisplay.vue'
import VehicleNameDisplay from '@/components/display/VehicleNameDisplay.vue'
import LatLongDisplay from '@/components/display/LatLongDisplay.vue'
import BaliseService from '@/services/balise.service'
import AlarmName from '@/components/display/AlarmDisplay.vue'

export default {
    components: {
        DefaultHeader,
        DefaultFooter,
        Pagination,
        BatteryDisplay,
        AlimDisplay,
        LatLongDisplay,
        VehicleNameDisplay,
        AlarmName
    },
    data() {
        return {
            baliseInfo: [],
            alerts: [],
            alarmTypes: [],
            selectedAlarmTypeIds: [],
            showAlarmTypeFilters: false,
            alertsCount: null,
            currentPage: 1,
            startResults: 0,
            perPage: 15,
            startDate: null,
            endDate: null,
            totalPages: 0
        }
    },
    mounted() {
        this.currentPage = this.getValidPageFromRoute()
        this.startResults = this.getStartResults(this.currentPage)

        this.init()
    },
    methods: {
        formatDateTimeFilter(value) {
            if (!value) {
                return null
            }

            return new Date(value).toISOString()
        },
        async init() {
            this.getBaliseInfos()
            await this.getAlarmTypes()
            this.getBaliseAlarms()
        },
        getValidPageFromRoute() {
            return Math.max(1, Number(this.$route.query.page) || 1)
        },
        getStartResults(page) {
            return (page - 1) * this.perPage
        },
        getBaliseInfos() {
            BaliseService.getBaliseInfo(this.$route.params.id)
                .then(response => {
                    this.baliseInfo = FormatHelper.baliseInfoFormat(response.data)
                })
                .catch(e => {
                    console.log(e)
                })
        },
        getAlarmTypes() {
            return AlarmRepository.getAlarmTypes()
                .then(result => {
                    this.alarmTypes = result
                    this.selectedAlarmTypeIds = []
                })
                .catch(e => {
                    console.log(e)
                })
        },
        getBaliseAlarms() {
            this.alerts = []

            return AlarmRepository.getBaliseAlarms(
                this.$route.params.id,
                this.startResults,
                this.perPage,
                this.formatDateTimeFilter(this.startDate),
                this.formatDateTimeFilter(this.endDate),
                this.selectedAlarmTypeIds
            )
                .then(result => {
                    this.alerts = result.rows
                    this.alertsCount = result.count
                    this.totalPages = Math.ceil(this.alertsCount / this.perPage)
                })
        },
        onPageChange(page) {
            const validPage = Math.max(1, Number(page) || 1)

            this.currentPage = validPage
            this.startResults = this.getStartResults(validPage)

            this.$router.replace({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    page: validPage
                }
            })

            this.getBaliseAlarms()
        },
        applyDateFilter() {
            this.onPageChange(1)
        },
        applyAlarmTypeFilter() {
            this.onPageChange(1)
        },
        selectAllAlarmTypes() {
            this.selectedAlarmTypeIds = this.alarmTypes.map(alarmType => alarmType.id)
            this.onPageChange(1)
        },
        unselectAllAlarmTypes() {
            this.selectedAlarmTypeIds = []
            this.onPageChange(1)
        },
        setPerPage(event) {
            this.perPage = Number(event.target.value) || 15
            this.onPageChange(1)
        }
    }
}
</script>